import React from 'react';

export const GDMELogo = ({ size = 'md' }) => {
  const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' };
  return <img src="/gdme-e-icon.svg" alt="GDME" className={sizes[size]} />;
};

export const TalkinPointLogo = ({ size = 'md' }) => {
  const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' };
  const fontSizes = { sm: '8px', md: '10px', lg: '12px' };
  return (
    <div className={`${sizes[size]} bg-gradient-to-br from-[#4A90E2] to-[#A855F7] rounded-md flex items-center justify-center`}>
      <span className="text-white font-bold" style={{ fontSize: fontSizes[size] }}>T</span>
    </div>
  );
};

export const getPlatformBadge = (platform) => {
  if (platform === 'gdme') return <GDMELogo size="sm" />;
  return <TalkinPointLogo size="sm" />;
};
